module.exports = __webpack_public_path__ + "static/img/img7.361879e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/product/images/img7.jpg
// module id = 0nG/
// module chunks = 1